// *******************************************************************
// DO NOT EDIT THIS FILE WITHOUT EXPLICIT SIGN OFF FROM THE MIGOS TEAM
// *******************************************************************

// The import statements below combine all of the files previously combined curalate-libs.
/* eslint-disable */

import './node_modules/jquery/dist/jquery';
import './node_modules/jquery.browser/dist/jquery.browser';
import './node_modules/jquery.inview/jquery.inview';
import './node_modules/jquery-sticky/jquery.sticky';
import './node_modules/sticky-kit/dist/sticky-kit';
import './node_modules/cramp.js/clamp';
import './node_modules/jquery-ui-dist/jquery-ui';
import './lib/bootstrap-3.1.1/dist/js/bootstrap';
import './node_modules/bootstrap-tour/build/js/bootstrap-tour';
import './node_modules/angular/angular';
import './node_modules/angular-animate/angular-animate';
import './node_modules/angular-cookies/angular-cookies';
import './node_modules/angular-messages/angular-messages';
import './node_modules/angular-toastr/dist/angular-toastr';
import './node_modules/angular-toastr/dist/angular-toastr.tpls';
import './node_modules/ng-file-upload/dist/angular-file-upload';
import './node_modules/angular-local-storage/dist/angular-local-storage';
import './node_modules/ng-table/ng-table';
import './node_modules/dangeruponu-nsPopover/src/nsPopover';
import './js/ui-bootstrap-tpls.min';
import './node_modules/select2/select2';
import './node_modules/angular-ui-select2/src/select2';
import './node_modules/angular-ui-router/release/angular-ui-router';
import './node_modules/typeahead.js/dist/typeahead.bundle';
import './node_modules/ngInfiniteScroll/build/ng-infinite-scroll';
import './node_modules/angular-bindonce/bindonce';
import './node_modules/underscore/underscore';
import './node_modules/moment/moment';
import './node_modules/moment-timezone/builds/moment-timezone-with-data-10-year-range';
import './node_modules/ment.io/dist/mentio';
import 'imagesloaded';
import './node_modules/angularjs-slider/dist/rzslider';
import './node_modules/rxjs/bundles/Rx';
import './node_modules/trackpad-scroll-emulator/jquery.trackpad-scroll-emulator';
import './node_modules/angular-uuid/angular-uuid';
import './node_modules/pannellum/src/js/libpannellum';
import './node_modules/pannellum/src/js/RequestAnimationFrame';
import './node_modules/pannellum/src/js/pannellum';
import './node_modules/object-fit-images/dist/ofi.browser';
import './node_modules/unison/dist/js/unison';
import './node_modules/angular-vs-repeat/src/angular-vs-repeat';
import './node_modules/highcharts-ng/dist/highcharts-ng';
import './js/highcharts-global-overrides';
